<template>
    <base-file-input
        v-model="model"
        v-validate="{
            required: !!identityInfoType,
        }"
        input-id="identity"
        input-label="CNIC BACK"
        :placeholder="
            originalFileName || 'Select scan copy (JPG, PNG or TIFF file)'
        "
        drop-placeholder="Drop file here..."
        file-type="identity"
        accept="image/*"
        data-vv-name="cnic back"
        :class="{
            'is-invalid': errors.has('document scan copy'),
        }"
        @update:originalFileName="updateOriginalFileName"
    ></base-file-input>
</template>

<script>
import TextField from './TextField'
export default {
    // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {},
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: TextField, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            default() {
                return {
                    isRequired: true,
                    isLocked: true,
                    key: 'documentInfo.cnicFront.fileName',
                    originalFileNameKey:
                        'documentInfo.cnicFront.originalFileName',
                }
            },
            required: false,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        identityInfoType() {
            return this.$store.getters.getField('identityInfo.type')
        },
        originalFileName() {
            return this.$store.getters.getField(this.field.originalFileNameKey)
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        updateOriginalFileName(newValue) {
            this.$store.commit('updateField', {
                key: this.field.originalFileNameKey,
                value: newValue,
            })
        },
    }, // End of Component > mounted
}
</script>
